import { render, staticRenderFns } from "./SelectMerchant.vue?vue&type=template&id=d90ab9b0&"
import script from "./SelectMerchant.vue?vue&type=script&lang=js&"
export * from "./SelectMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports